<div class="mt-2">
  <div class="row">
    <div class="col-md-10 mt-3">
      <h4 class="title"><i class="fa fa-code-branch"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-2 mt-3 content-position-end">
      <button type="button"
              class="btn btn-outline-success mw-180 font-weight-bold custom-button"
              *ngIf="hasAuthority('own:workflow:add')"
              (click)="openModalAdd()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="bg-white-radius">
  <div class="row">
    <div class="col-md-2 custom-mr-17 custom-col-md-2" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold">
        {{ "LABEL.PARTNER" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
        </div>
        <select *ngIf="hasRole(ROLE_SUPERADMIN)"
                class="form-control  mr-2"
                [(ngModel)]="partnerSelected"
                (ngModelChange)="reloadWorkflows0()">
          <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-2 custom-mr-17 custom-col-md-2" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
      <label class="font-weight-bold">
        {{ "LABEL.ENTERPRISE" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
        </div>
        <select *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)"
                class="form-control mr-2"
                [(ngModel)]="enterpriseSelected"
                (ngModelChange)="reloadWorkflows()">
          <option *ngFor="let enterprise of enterprises"
                  [ngValue]="enterprise">{{enterprise.name | translate}}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3 custom-mr-17 custom-col-md-2">
      <label class="font-weight-bold">{{ "LABEL.DESCRIPTION" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-keyboard" aria-hidden="true"></i></div>
        </div>
        <input type="text"
               id="searchInput"
               class="form-control"
               placeholder="{{ 'MESSAGE.ENTER-TO-SEARCH' | translate }}"
               [(ngModel)]="term2Search"
               (keyup.enter)="search()">
      </div>
    </div>
    <div class="col-md-2 custom-mt-12">
      <button type="button"
              class="btn btn-outline-success custom-button custom-mt-24"
              [disabled]="term2Search === undefined"
              (click)="search()"><i class="fas fa-search"></i> {{ "BUTTON.SEARCH" | translate }}
      </button>
    </div>
  </div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col" title="Identificador"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.FLOW' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.TYPE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.SIGNATURE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DYNAMIC' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.MAX-PARTICIPANTS' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.READY-TO-USE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.SIE-INTEGRATION' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.REQUISITE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.STATE' | translate }}"></th>
        <th scope="col" title="{{ 'TABLE.HEADER.ACTION' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let workflow of workflows">
        <td title="Identificador"><b>{{workflow.id}}</b></td>
        <td title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}">{{workflow._more.enterpriseTradeName}}</td>
        <td title="{{ 'TABLE.HEADER.FLOW' | translate }}">{{workflow.description}}</td>
        <td title="{{ 'TABLE.HEADER.TYPE' | translate }}">{{getWorkflowtypeDesc(workflow)}}</td>
        <td title="{{ 'TABLE.HEADER.SIGNATURE' | translate }}">
          <span>{{workflow.batch ? ('TABLE.HEADER.IN-BATCH' | translate) : ('TABLE.HEADER.ONE-TO-ONE' | translate)}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.DYNAMIC' | translate }}">
        <span
          class="badge {{isDynamic(workflow)? ' badge-primary': isFreelySignature(workflow) ? ' badge-success' : ''}}">
          {{isDynamic(workflow) ? ('TABLE.HEADER.DYNAMIC' | translate) : isFreelySignature(workflow) ? ('TABLE.HEADER.FREE' | translate) : '-'}}
        </span>
        </td>
        <td title="{{ 'TABLE.HEADER.MAX-PARTICIPANTS' | translate }}">{{workflow.maxParticipants}}</td>
        <td title="{{ 'TABLE.HEADER.READY-TO-USE' | translate }}">
        <span class="{{!ready2Use(workflow)? 'badge badge-danger':'badge badge-success'}}">
          {{ready2Use(workflow) ? ('LABEL.YES' | translate) : 'No'}}
        </span>
        </td>
        <td title="{{ 'TABLE.HEADER.SIE-INTEGRATION' | translate }}">
        <span class="{{requiredSieConfig(workflow)? 'badge badge-info':'badge badge-secondary'}}">
          {{requiredSieConfig(workflow) ? ('LABEL.YES' | translate) : 'No'}}
        </span>
        </td>
        <td title="{{ 'TABLE.HEADER.REQUISITE' | translate }}">
        <span *ngIf="!completed(workflow)" class="badge badge-dark">
          {{ "TABLE.HEADER.PARTICIPANT" | translate }}
        </span>
          <span *ngIf="requiredHasTemplate(workflow)"
                class="{{requiredHasTemplate(workflow)? 'badge badge-secondary':''}}">
          {{ "TABLE.HEADER.ADD-JASPER" | translate }}
        </span>
          <span *ngIf="requiredTenorConfig(workflow)"
                class="{{requiredTenorConfig(workflow)? 'badge badge-primary':''}}">
          {{ "TABLE.HEADER.CONTENT" | translate }}
        </span>
          <span *ngIf="requiredSieConfig(workflow)"
                class="{{!sieConfigured(workflow)? 'badge badge-warning':''}}">
          {{!sieConfigured(workflow) ? 'Config. SIE' : '-'}}
        </span>
          <span
            *ngIf="!requiredSieConfig(workflow) && !requiredTenorConfig(workflow) && !requiredHasTemplate(workflow) && completed(workflow)">
          -
        </span>
        </td>
        <td title="{{ 'TABLE.HEADER.DATE' | translate }}">{{workflow.createAt | dateformat}}</td>
        <td title="{{ 'TABLE.HEADER.STATE' | translate }}">
        <span
          class="{{!workflow.active? 'badge badge-danger':''}}">{{workflow.active ? ('TABLE.HEADER.ACTIVE' | translate) : ('TABLE.HEADER.INACTIVE' | translate)}}</span>
        </td>
        <td title="{{ 'TABLE.HEADER.ACTION' | translate }}">
          <div class="dropdown">
            <button type="button" class="btn btn-default " id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:participant:add:workflow') && !isDynamic(workflow)"
                      (click)="openModalAddParticipants(workflow)">
                <i class="fa fa-user-plus"></i> {{ "BUTTON.ASSIGN-PARTICIPANTS" | translate }}
              </button>
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:workflow:template:add') && hasAuthority('own:workflow:template:edit') && hasAuthority('own:workflow:template:get')"
                      (click)="getParticipantsAndOpen(workflow)">
                <i class="fa fa-crop"></i> {{ "BUTTON.DESIGN-TEMPLATE" | translate }}
              </button>
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:workflow:config:tenor') && hasEnabledNotificationByDocument(workflow) || hasEnabledNotcertByDocument(workflow)"
                      (click)="openModalConfigEmailTemplate(workflow, sendDocumentAlertAttachment)">
                <i class="fa fa-envelope"></i> {{ "BUTTON.CONFIGURE-TENOR" | translate }}
              </button>
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:workflow:config:email:alert') && !isNotcer(workflow)"
                      (click)="openModalConfigEmailTemplate(workflow, sendDocumentAlertPending)">
                <i class="fa fa-envelope"></i> {{ "BUTTON.CONF-EMAIL-BODY-TEMPLATE-ALERT" | translate}}
              </button>
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:workflow:duplicate') && isActive(workflow)"
                      (click)="duplicate(workflow)">
                <i class="fa fa-copy"></i> {{ "BUTTON.DUPLICATE-FLOW" | translate }}
              </button>
              <button class="dropdown-item poniter"
                      *ngIf="hasAuthority('own:workflow:edit')"
                      (click)="openModalEdit(workflow)">
                <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
              </button>
              <button class="dropdown-item pointer"
                      *ngIf="hasAuthority('own:workflow:delete')"
                      (click)="delete(workflow)">
                <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <div class="justify-content-row">
          <span class="mr-1 font-weight-normal">Mostrar </span>
          <select class="mr-1 br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="loadWorkflow(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <span class="font-weight-normal"> registros.</span>
        </div>
        <div class="page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{workflows.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadWorkflow(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadWorkflow(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadWorkflow(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadWorkflow(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
